/// <amd-module name="TFS/Views/ProjectOverviewPage/Components/ProjectVisibilityTag" />
import * as React from "react";

import * as ProjectOverviewResources from "TFS/Views/ProjectOverviewPage/Resources";
import { format } from "VSS/Core/Util/String";
import { Button } from "VSSUI/Button";

export interface ProjectVisibilityTagProps {
    visibility: string;
    className?: string;
    isSmallScreen: boolean;
}

// TODO: Get this from generated constants file
namespace ProjectVisibilityConstants {
    export let EveryoneInTenant = "EveryoneInTenant";
    export let TeamMembers = "TeamMembers";
    export let Everyone = "Everyone";
}

interface VisibilityInfo {
    iconName: string;
    displayText: string;
    tooltipText: string;
}

export const ProjectVisibilityTag: React.StatelessComponent<ProjectVisibilityTagProps> = (props: ProjectVisibilityTagProps): JSX.Element | null => {
    if (props.visibility) {
        const { tooltipText, iconName, displayText } = getVisibilityInfo(props.visibility); 

        return (
            
            <Button
                className={props.className}
                iconProps={{iconName:iconName}}
                ariaLabel={tooltipText}
                ariaDisabled={true}
                autoFocus={false} 
                excludeTabStop={true}
                tooltipProps={{text:tooltipText}}
            >
                {
                    props.isSmallScreen ? "" : <span aria-hidden="true" className="body-m">{displayText}</span>
                }
            </Button>
        );
    }

    return null;
};

function getVisibilityInfo(visibility: string): VisibilityInfo {
    switch (visibility) {
        case ProjectVisibilityConstants.TeamMembers:
            return {
                displayText: "Private",
                iconName: "Lock",
                tooltipText: ProjectOverviewResources.VisibilityTag_PrivateProject_Tooltip_Text
            };
        case ProjectVisibilityConstants.EveryoneInTenant:
            return {
                displayText: "Enterprise",
                iconName: "CityNext",
                tooltipText: ProjectOverviewResources.VisibilityTag_OrgVisibleProject_Tooltip_Text
            };
        case ProjectVisibilityConstants.Everyone:
            return {
                displayText: "Public",
                iconName: "Globe",
                tooltipText: ProjectOverviewResources.VisibilityTag_PublicProject_Tooltip_Text
            };
        default:
            throw new Error(format(ProjectOverviewResources.VisibilityTag_VisibilityValueInvalid, visibility));
    }
}
